export enum ButtonClass {
  'Raised' = 'mat-raised-button',
  'Icon' = 'mat-icon-button',
  'Fab' = 'mat-fab',
  'MiniFab' = 'mat-mini-fab',
  'Stroked' = 'mat-stroked-button',
  'Flat' = 'mat-flat-button',
}
